import { lazyWithPreload } from '../../navigation';

export const LinkAuditScreen = lazyWithPreload(() => import('./LinkAuditScreen.lazy'));

export type { LinkAuditScreenProps } from './LinkAuditScreen.lazy';
